<template>
    <div class="editprosection" id="dashboard">
        <div class="row blockcont topactionform smallmargin">
            <div class="col-xs-10">
                <div class="smalltitle">Communication</div>
            </div>
            <div class="col-xs-2">
      
                <form  @submit.prevent="changeFilterDate">
                <date-picker v-model="filterDateAppointment"
                             format="MM/DD/YYYY"
                             :clearable=false
                             @change="changeFilterDate"
                             :append-to-body=true
                             :custom-button="true"
                             lang="en"></date-picker>
                </form>
            </div>
            <p class="error-text none-select-location" v-show="showErrorNewInject">Please choose your clinic location at
                the top menu before create new injection</p>
        </div>
        <div class="dashboardwrap">
            <div class="row">
                <div class="col-xs-5">
                    <div class="dashboardblock">
                        <div class="headnote">
                            <span title="Conventional Immunotherapy">Contact form</span>
                        </div>
                        <ul class="itemlisttable contact-form-list conventlist samebglist scroll long"
                            :class="{condenselist: condenseConven}">
                            <li class="itemlisthead">
                                <div>Date</div>
                                <div class="contact-form-name">Name</div>
                                <div>Email</div>
                                <div>Source</div>
                                <div>Phone</div>
                                <div>Status</div>
                                <div class="itemaction" style="min-height: 1px;"></div>
                            </li>
                            <li class="contact-form-item"
                                v-for="(contact, index) in contactForms">
                              <div @click.prevent="showDetailContact(contact)">
                                {{ contact.createdAt ? formatTime(contact.createdAt) : "" }}</div>
                                <div class="contact-form-name"
                                     @click.prevent="showDetailContact(contact)">
                                  {{ contact.fullName }}
                                </div>
                                <div @click.prevent="showDetailContact(contact)">{{ contact.email }}</div>
                                <div :title="contact.source" @click.prevent="showDetailContact(contact)">{{ contact.source || "" }}</div>
                                <div @click.prevent="showDetailContact(contact)">{{ formatPhone(contact.phone) }}</div>

                                <div @click.prevent="changeStatus(contact)">{{ contact.statusText }}</div>
                                <div class="itemaction">
                                    <dropdown append-to-body :menuRight="true">
                                        <a href="javascript:void(0)" title="Choose action" data-toggle="dropdown"><i
                                                class="fa fa-cog"></i></a>
                                        <template slot="dropdown">
                                            <div v-if="contact.status !== 'Read'">
                                                <a href="javascript:void(0)" @click.prevent="changeStatus(contact, 'Read')"
                                                   title="Mark as Read">Mark as Read</a>
                                            </div>
                                            <div v-if="contact.status !== 'Pending'">
                                                <a href="javascript:void(0)" @click.prevent="changeStatus(contact, 'Pending')"
                                                   title="Mark as Pending">Mark as Pending</a>
                                            </div>
                                            <div v-if="contact.status !== 'Resolve'">
                                                <a href="javascript:void(0)" @click.prevent="changeStatus(contact, 'Resolve')"
                                                   title="Mark as Resolved">Mark as Resolved</a>
                                            </div>
                                        </template>
                                    </dropdown>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-xs-7 bigcol">
                    <div class="dashboardblock">
                        <div class="headnote">Support</div>
                        <ul class="itemlisttable injectionlist scroll short clusterlist samebglist">
                            <li class="itemlisthead">
                                <div class="bill-mrn">#</div>
                                <div style="width: 10% !important;">Date</div>
                                <div style="width: 57% !important;float: left">Subject</div>
                                <div style="width: 10% !important;float: left">From</div>
                                <div style="width: 15% !important;text-align: right !important; padding-right: 0px !important;">Status</div>
                            </li>
                            <li v-if="isLoadingContact" style="text-align: center; color: #d9df20; font-size: 16pt">
                                <i class="fas fa-spinner fa-spin"></i>
                            </li>
                            <li style="cursor: pointer;" v-for="(item, index) in dataListSupport" @click.prevent="openConversation(item)">
                                <div class="bill-mrn">{{ item.code }}</div>
                                <div style="width: 10% !important;">{{ formatTimeSignature(item.createdAt) }}</div>
                                <div style="width: 57% !important;float: left">{{ item.subject }}</div>
                                <div style="width: 10% !important;float: left; text-align: left !important;">Emr</div>
                                <div style="width: 15% !important;float: left;">
                                    <span><i class="far fa-comment"></i></span>
                                    <span style="margin-left: 10px;">{{ item.status }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="heightdrag" id="heightdrag"></div>
                    <div class="dashboardblock">
                        <div class="headnote">Reports</div>
                        <!--biologic injection-->
                        <ul class="itemlisttable injectionlist scroll short2 bilologiclist samebglist list-biologic-injection"
                            :class="{condenselist: condenseBio}">
                            <li class="itemlisthead">
                                <div style="width: 15% !important;">
                                    User Action
                                </div>
                                <div style="width: 30% !important;">Personal/Post/Question</div>
                                <div style="width: 40% !important;">Reason</div>
                                <div style="width: 15% !important;">Time</div>
                            </li>
                            <li v-for="(item) in dataReports">
                              <div style="width: 15% !important;">
                                <span v-if="item.userAction">{{ item.userAction.fullName }}</span>
                              </div>
                              <div style="width: 30% !important;"><span v-if="item.objectData">{{ item.objectData.fullName }}</span></div>
                              <div style="width: 40% !important; text-align: left !important;">{{ item.reason }}</div>
                              <div style="width: 15% !important;">{{ item.created_at | formatDateTime }}</div>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
            <div class="heightdrag" id="heightdrag2"></div>
        </div>


        <modal class="skintestblock" v-model="modalDetailContact" :backdrop="false">
            <h4 slot="title" class="smalltitle">Detail Contact</h4>
            <div class="prolabel fullw">
                <p>Full Name: {{ detailContact.fullName}} </p>
                <p>Email: {{ detailContact.email}} </p>
                <p>Source: {{ detailContact.source || ""}} </p>
                <p>Phone : {{ formatPhone(detailContact.phone) }} </p>
                <p>Date : {{ formatTime(detailContact.createdAt) }} </p>
                <p>Subject: {{ detailContact.subject}} </p>
                <p>Company name: {{ detailContact.companyName}} </p>
                <p>Number doctors: {{ detailContact.numberDoctors}} </p>
                <p>Message: {{ detailContact.message}} </p>
            </div>
            <!--</form>-->
            <div slot="footer">
                <button type="button" class="btn btn-default" @click.prevent="modalDetailContact = false">Close</button>
            </div>
        </modal>

        <modal id="support-conversation-modal" v-model="conversationData.modal" :append-to-body="true" size="max" @hide="hideModalConversation">
            <div slot="title">
                <button type="button" class="close" @click.prevent="conversationData.modal = false">×</button>
                <div class="row">
                    <div class="col-xs-6">
                        <h4 class="smalltitle">
                            {{ conversationData.title }}
                        </h4>
                    </div>
                </div>
            </div>
            <div class="body">
                <div class="block-add-conversation">
                    <div class="emr-mes scroll box" ref="messageDisplay" style="height: 600px;">
                        <ul class="chatmesagelist">
                            <li :class="msg.from ? 'sent' : 'received'" v-for="(msg, index) in conversationData.messages">
                                <div class="mesinfo">
                                    <span>{{msg.fullName}} sent on {{ msg.created_at | formatDateTime }}</span>
                                </div>
                                <div class="mescont adjustcard">
                                    <span> {{ msg.content }} </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <form class="onelineform chatform" v-if="conversationData.status !== 'Resolve'">
                    <input style="width: 68%; border-left: 1px solid #e1e1e1;" type="text" ref="chat_form_appointment"
                           v-model="message"
                           placeholder="Say Something"
                           class="mestext">
                    <button style="width: 16%" class="btn" @click.prevent="createMessage()">Reply </button>
                    <button style="width: 15%; margin-left: 5px !important;" @click.prevent="closeTicket()" class="btn">Close Ticket</button>
                </form>
                <button class="btn" v-if="conversationData.status === 'Resolve'" @click.prevent="hideModalConversation()">Close </button>
            </div>
        </modal>
    </div>
</template>

<script>
import axios from '../../client'
import config from '../../config'
import Common from '../mixins/Common.vue'
import CountDown from './part/Countdown.vue'
import { Howl } from 'howler'
import { mapGetters } from 'vuex'
import moment from 'moment'
import DatePicker from '../../global/datepicker/DatePickerCustom.vue'
import { formatDate } from 'vue2-datepicker/src/utils'



export default {
  name: 'Dashboard',
  components: {
    CountDown,
    DatePicker
  },
  mixins: [Common],
  data () {
    return {
      filterDateAppointment: moment(),
      STATUS_END: 1,
      isLoadingRushData: false,
      dischargeTimeCountDown: {
        modal: false,
        data: null,
        patient: null
      },
      dischargeInjection: {
        modal: false,
        rushData: {}
      },
      modalNewInjectionBiologic: false,
      noReactionData: {
        email: '',
        password: ''
      },
      modalAskReaction: false,
      modalNoReaction: false,
      dataStartSounds: [],
      convenEndSounds: [],
      rushEndSounds: [],
      bioEndSounds: [],

      convenWaitingSounds: [],
      rushWaitingSounds: [],
      bioWaitingSounds: [],

      startCountDownConven: 'mute',
      endCountDownConven: 'mute',
      soundWaitingConven: 'mute',

      startCountDownRush: 'mute',
      endCountDownRush: 'mute',
      soundWaitingRush: 'mute',

      startCountDownBio: 'mute',
      endCountDownBio: 'mute',
      soundWaitingBio: 'mute',

      isPlayWaiting: true,
      isPlayStart: true,
      isPlayEnd: true,

      condenseConven: false,
      condenseBio: false,
      condenseRushCluster: false,
      modalInjection: false,
      modalInjectionRush: false,
      modalEditInject: false,
      processEditInject: true,
      dropDownNotClose: [],

      itemConventionalNotReaction: null,
      clinicStaffs: [],
      showErrorNewInject: false,
      selectedStaff: '',
      selectedLocation: {
        _id: '',
        name: '',
        address: ''
      },
      soundDemoPlay: null,
      soundLoop: null,
      locations: [],

      modalNewPatient: false,
      newPatient: {},
      newPatientProfile: {},
      newPatientPrimaryInsurance: {},
      newPatientSecondaryInsurance: {},
      tempIndex: '',
      editInjection: null,
      tempPatient: {},
      modalDetailPatient: false,
      processStartCountDown: false,

      isLoadingContactFormata: false,
      contactForms: [],
      modalDetailContact: false,
      detailContact: {},

      isLoadingContact: false,
      dataListSupport: [],
      conversationData: {
        modal: false,
        subject: '',
        supportId: '',
        messages: []
      },
      message: '',
      dataReports: []
    }
  },
  computed: {
    ...mapGetters({
      storeLocations: 'locations',
      storeStaffs: 'staffs',
      storeSelectedLocation: 'selectedLocation',
      storeSelectedStaff: 'selectedStaff',
      storeLocationObject: 'locationObject'
    })
  },
  watch: {
    'condenseConven' (newVal, oldVal) {
      this.$store.commit('setCondenseConventional', newVal)
    },
    'condenseRushCluster' (newVal, oldVal) {
      this.$store.commit('setCondenseRush', newVal)
    },
    'condenseBio' (newVal, oldVal) {
      this.$store.commit('setCondenseBiologic', newVal)
    }
  },
  mounted () {
    $('#newinjectsearch').find('.modal-dialog').addClass('modal-max')
    this.initDragHeight()

    this.getDataContactForm()
    this.initDataListSupport()
    this.initDataListReport()
  },
  beforeDestroy () {
    if (this.internalInjectionListener) {
      clearInterval(this.internalInjectionListener)
    }
  },
  methods: {
    formatDate,
    closeTicket () {
      let data = {
        supportId: this.conversationData.supportId,
        status: 'Resolve'
      }
      axios.post('/support/close-ticket', data).then((response) => {
        if (response.data.s === 200) {
          this.conversationData.messages.push(response.data.data)
          this.dataListSupport = this.dataListSupport.map(item => {
            if (item._id == this.conversationData.supportId) {
              item.status = 'Resolve'
            }
            return item
          })
        } else {
          this.alertError(response.data.msg)
        }
      }).catch((error) => {
        this.alertError(error.message)
      })
    },
    createMessage () {
      if (!this.message) {
        return
      }

      let data = {
        supportId: this.conversationData.supportId,
        content: this.message
      }
      axios.post('/support/add-reply', data).then((response) => {
        if (response.data.s === 200) {
          let data = response.data.data
          data.from = 1
          this.conversationData.messages.push(data)
          this.dataListSupport = this.dataListSupport.map(item => {
            if (item._id == this.conversationData.supportId) {
              item.conversations = this.conversationData.messages
            }
            return item
          })
          this.message = ''
        } else {
          this.alertError(response.data.msg)
        }
      }).catch((error) => {
        this.alertError(error.message)
      })
    },
    hideModalConversation () {
      this.conversationData.modal = false
    },
    openConversation (data) {
      this.conversationData.supportId = data._id
      this.conversationData.status = data.status
      this.conversationData.title = data.subject
      this.conversationData.messages = data.conversations.map(item => {
        item.from = item._id == this.$store.state.user.id
        return item
      })
      this.conversationData.modal = true
    },
    async initDataListSupport () {
      this.isLoadingContact = true
      try {
        let params = {}
        let response = await axios.get('/get-list-supports', { params: params })
        this.isLoadingContact = false
        let data = response.data
        if (data.s === 200) {
          this.dataListSupport = data.data
        }
      } catch (e) {
        this.isLoadingContact = false
        console.log(e.stack, '22')
      }
    },
    async initDataListReport () {
      try {
        let params = {}
        let response = await axios.get('/get-list-reports', { params: params })
        let data = response.data
        if (data.s === 200) {
          this.dataReports = data.data
        }
      } catch (e) {
        console.log(e.stack, '22')
      }
    },
    changeFilterDate () {

    },
    getDataContactForm () {
      if (this.isLoadingContactFormata) {
        return
      }
      this.isLoadingContactFormata = true
      axios.get(`/contact-form/list`).then(response => {
        this.isLoadingContactFormata = false
        let data = response.data
        if (data.s === 200) {
          let result = data.data
          this.contactForms = result.contacts
          console.log('contactForms', this.contactForms)
        }
      })
    },

  
    initDragHeight () {
      let top1H, bottom1H, top2H, wrapH, shiftInitial
      let drag1
      $('#heightdrag').draggable({
        axis: 'y',
        start: function (event, ui) {
          shiftInitial = ui.position.top
          top1H = $('.clusterlist').height()
          bottom1H = $('.bilologiclist').height()
        },
        drag: function (event, ui) {
          //            $('.heightdrag').popover("hide");
          let shift = ui.position.top
          $('.clusterlist').height(top1H + shift - shiftInitial)
          $('.bilologiclist').height(bottom1H - shift + shiftInitial)
        }
      })
      $('#heightdrag2').draggable({
        axis: 'y',
        start: function (event, ui) {
          shiftInitial = ui.position.top
          top1H = $('.clusterlist').height()
          bottom1H = $('.bilologiclist').height()
          top2H = $('.conventlist').height()
          wrapH = $('.dashboardwrap').height()
          drag1 = $('#heightdrag').position().top
        },
        drag: function (event, ui) {
          //            $('.heightdrag').popover("hide");
          let shift = ui.position.top
          $('.dashboardwrap').height(wrapH + shift - shiftInitial)
          $('.conventlist').height(top2H + shift - shiftInitial)
          $('.clusterlist').height(top1H + (shift - shiftInitial) / 2)
          $('.bilologiclist').height(bottom1H + (shift - shiftInitial) / 2)
          let dragchange = drag1 + (shift - shiftInitial) / 2
          dragchange = dragchange + 'px'
          $('#heightdrag').css('top', dragchange)
        }
      })
    },

    changeStatus (contact, status) {
      let stattusText = contact.statusText
      if (!status) { // change status by click on status
        if (contact.status === 'NotRead') {
          status = 'Read'
        } else if (contact.status === 'Pending') {
          status = 'Resolve'
        } else if (contact.status === 'Read') {
          status = 'Pending'
        } else if (contact.status === 'Resolve') {
          status = 'NotRead'
        }
      }
      axios.put(`/contact-form/change-status`, {
        id: contact.id,
        status: status
      }).then(response => {
        if (response.data.s === 200) {
          contact.status = status
          contact.statusText = this.getStatusText(status)
          this.$forceUpdate()
        }
      }).catch(e => {
        this.alertError(e.message)
      })
    },
    getStatusText (status) {
      if (status === 'NotRead') {
        return 'Not Read'
      }

      if (status === 'Read') {
        return 'Read'
      }

      if (status === 'Pending') {
        return 'Pending'
      }
      if (status === 'Resolve') {
        return 'Resolved'
      }

      if (status === 'Deleted') {
        return 'Deleted'
      }
    },
    showDetailContact (contact) {
      this.detailContact = contact
      this.modalDetailContact = true
    }
  }

}
</script>
<style>
</style>
<style scoped>
    .itemlisthead > div {
        cursor: pointer;
    }

    .contact-form-item div {
        cursor: pointer;
    }

    .dashboardblock > .contact-form-list {
        padding-top: 33px;
    }

    .contact-form-list.long {
        height: calc(100vh - 380px);
        overflow-y: scroll;
    }

    .contact-form-list .itemlisthead {
        background: #ebebeb;
    }

    .contact-form-list > li {
        padding-top: 7px !important;
        padding-bottom: 5px !important;
    }

    .contact-form-list > li > div:nth-child(1) {
        width: 15% !important;
        padding-left: 5px;
    }

    .contact-form-list > li > div:nth-child(2) {
        width: 25% !important;
        text-align: left !important;
    }

    .contact-form-list > li > div:nth-child(3) {
        width: 20% !important;
        text-align: left !important;
    }

    .contact-form-list > li > div:nth-child(4) {
        width: 10% !important;
        text-align: left !important;
    }

    .contact-form-list > li > div:nth-child(5) {
        width: 15% !important;
    }

    .contact-form-list > li > div:nth-child(6) {
        width: 10% !important;
        text-align: center !important;
    }

    .contact-form-list > li > div:nth-child(7).itemaction {
        width: 5% !important;
        text-align: right;
        padding-right: 10px;
    }

    .contact-form-name {
        text-align: left !important;
    }

    .clustersublist li div {
        min-height: 1px;
    }

    .none-select-location {
        float: right;
        margin-top: 5px;
    }

    .error-text {
        color: red;
    }

    .injectionlist > li > div {
        min-height: 19px;
    }

    .count-down-block {
        /*padding-left: 15px;*/
    }

    @keyframes flickerAnimation {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    @-o-keyframes flickerAnimation {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    @-moz-keyframes flickerAnimation {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    @-webkit-keyframes flickerAnimation {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    .animate-flicker {
        -webkit-animation: flickerAnimation .5s infinite;
        -moz-animation: flickerAnimation .5s infinite;
        -o-animation: flickerAnimation .5s infinite;
        animation: flickerAnimation .5s infinite;
        color: red;
    }

    .item-rush-injection {
        width: 100%;
    }

    .clusterlist > li > div:nth-child(4).rush-action {
        width: 14.5% !important;
    }

    .clusterlist > .itemlisthead > div:nth-child(2) {
        width: 10.5% !important;
    }

    .clusterlist > .itemlisthead > div:nth-child(3) {
        margin-top: 0px !important;
        width: 9% !important;
    }

    .clusterlist > .itemlisthead > div:nth-child(4) {
        margin-top: 0px !important;
        width: 8.5% !important;
        padding-right: 5px;
    }

    .clusterlist > .itemlisthead > div:nth-child(5) {
        margin-top: 0px !important;
        width: 6% !important;
        text-align: center !important;
        padding-right: 0px !important;
    }

    .clusterlist > .itemlisthead > div:nth-child(6) {
        width: 5% !important;
        text-align: center !important;
    }

    .clusterlist > .itemlisthead > div:nth-child(7) {
        width: 7.5% !important;
        text-align: center !important;
    }

    .clusterlist > .itemlisthead > div:nth-child(8) {
        width: 7.5% !important;
        text-align: center !important;
    }

    .clusterlist > .itemlisthead > div:nth-child(9) {
        width: 7.5% !important;
        text-align: center !important;
    }

    .clusterlist > .itemlisthead > div:nth-child(10) {
        width: 8.5% !important;
        text-align: center !important;
        padding-right: 0px !important;
    }

    .clusterlist > .itemlisthead > div:nth-child(11) {
        width: 9% !important;
        text-align: center !important;
        padding-right: 0px !important;
    }

    .clusterlist > .itemlisthead > div:nth-child(12) {
        width: 13% !important;
        min-width: 85px !important;
        text-align: right !important;
    }

    .clustersublist > li {
        left: 0px !important;
    }

    .clustersublist > li > div:nth-child(1) {
        margin-top: 0px !important;
        width: 7% !important;
    }

    .clustersublist > li > div:nth-child(2) {
        margin-top: 0px !important;
        width: 10.5% !important;
    }

    .clustersublist > li > div:nth-child(3) {
        margin-top: 0px !important;
        width: 9% !important;
    }

    .clustersublist > li > div:nth-child(4) {
        width: 8.5% !important;
    }

    .clustersublist > li > div:nth-child(5) {
        width: 6% !important;
        text-align: center !important;
    }

    .clustersublist > li > div:nth-child(6) {
        width: 5% !important;
        text-align: center !important;

    }

    .clustersublist > li > div:nth-child(7) {
        width: 7.5% !important;
        text-align: center !important;
    }

    .clustersublist > li > div:nth-child(8), .clustersublist > li > div:nth-child(9) {
        width: 7.5% !important;
        text-align: center !important;
    }

    .clustersublist > li > div:nth-child(10) {
        width: 8.5% !important;
        text-align: center !important;
        padding-right: 0px !important;
    }

    .clustersublist > li > div:nth-child(11) {
        width: 9% !important;
        text-align: center !important;
    }

    .clustersublist > li > div:nth-child(12) {
        width: 13% !important;
        padding-right: 0px !important;
        text-align: right !important;
        min-width: 85px !important;
        margin-left: 5px;
    }

    .rush-item-shot {
        margin-bottom: 7px;
    }

    .discharge-block {
        width: 100%;
        display: block;
        border-top: 1px solid #e1e1e1;
        padding-top: 7px;
    }

    .discharge-bill {
        min-height: 1px;
        width: 7%;
        float: left;
    }

    .discharge-title {
        width: 10.5% !important;
        float: left;
    }

    .discharge-start {
        width: 8.5% !important;
        display: block;
        float: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center !important;
    }

    .discharge-count-down {
        width: 9% !important;
        float: left;
        display: block;
        text-align: center !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
    }

    .discharge-action {
        width: 13% !important;
        text-align: right !important;
        display: block;
        float: left;
        margin-left: 5px;
    }

    .discharge-space {
        min-height: 1px;
        display: block;
        float: left;
        width: 23.5% !important;
    }

    .discharge-hr {
        float: left;
        width: 5% !important;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .discharge-bp, .discharge-pl {
        width: 7.5% !important;
        float: left;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .discharge-po {
        width: 7.5% !important;
        float: left;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    /*//conventional */
    .list-conventional-injection > li > div:nth-child(1) {
        width: 10% !important;
    }

    .list-conventional-injection > li > div:nth-child(2) {
        width: 18% !important;
    }

    .list-conventional-injection > li > div:nth-child(3) {
        width: 13% !important;
        text-align: center;
    }

    @media (min-width: 1800px) {
        .fullscreen .list-conventional-injection > li > div:nth-child(3) {
            width: 19% !important;
        }
    }

    .list-conventional-injection > li > div:nth-child(4) {
        width: 10% !important;
        text-align: left;
    }

    .list-conventional-injection > li > div:nth-child(5) {
        width: 8% !important;
        text-align: center !important;
    }

    @media (min-width: 1800px) {
        .fullscreen .list-conventional-injection > li > div:nth-child(5) {
            width: 12% !important;
        }
    }

    .list-conventional-injection > li > div:nth-child(6) {
        width: 12% !important;
        text-align: center !important;
    }

    .list-conventional-injection > li > div:nth-child(7) {
        width: 10% !important;
        max-width: 50px;
        text-align: center !important;
    }

    .list-conventional-injection > li > div:nth-child(8) {
        width: 11% !important;
        min-width: 85px !important;
        text-align: right;
        float: right;
    }

    /*//biologc*/

    .bilologiclist > li > div:nth-child(4).rush-action {
        width: 14.5% !important;
    }

    .bilologiclist > .itemlisthead > div:nth-child(3) {
        margin-top: 0px !important;
        width: 8.5% !important;
        text-align: left !important;
    }

    .bilologiclist > .itemlisthead > div:nth-child(4) {
        width: 6% !important;
        text-align: center !important;
        padding-right: 0px !important;
    }

    .bilologiclist > .itemlisthead > div:nth-child(5) {
        width: 5% !important;
        text-align: center !important;
    }

    .bilologiclist > .itemlisthead > div:nth-child(6) {
        width: 7.5% !important;
        text-align: center !important;
    }

    .bilologiclist > .itemlisthead > div:nth-child(7) {
        width: 7.5% !important;
    }

    .bilologiclist > .itemlisthead > div:nth-child(8) {
        width: 7.5% !important;
        text-align: center !important;
    }

    .bilologiclist > .itemlisthead > div:nth-child(9) {
        width: 8.5% !important;
        text-align: center !important;
        padding-right: 0px !important;
    }

    .bilologiclist > .itemlisthead > div:nth-child(10) {
        width: 9% !important;
        text-align: center !important;
    }

    .bilologiclist > .itemlisthead > div:nth-child(11) {
        width: 13% !important;
        text-align: right !important;
    }

    .bilologiclist > li > div:nth-child(2) {
        width: 19.5% !important;
    }

    .bilologiclist > li > div:nth-child(3) {
        width: 8.5% !important;
        text-align: center !important;
    }

    .bilologiclist > li > div:nth-child(4) {
        width: 6% !important;
        text-align: center !important;
    }

    .bilologiclist > li > div:nth-child(5) {
        width: 5% !important;
        text-align: center !important;
        padding-right: 0px !important;
    }

    .bilologiclist > li > div:nth-child(6) {
        width: 7.5% !important;
        text-align: center !important;
    }

    .bilologiclist > li > div:nth-child(7) {
        width: 7.5% !important;
        text-align: center !important;
    }

    .bilologiclist > li > div:nth-child(8) {
        width: 7.5% !important;
        text-align: center !important;
    }

    .bilologiclist .clustersublist > li > div:nth-child(1) {
        width: 7% !important;
    }

    .bilologiclist .clustersublist > li > div:nth-child(2) {
        width: 19.5% !important;
    }

    .bilologiclist .clustersublist > li > div:nth-child(3) {
        text-align: left !important;
        width: 8.4% !important;
    }

    .bilologiclist .clustersublist > li > div:nth-child(4) {
        text-align: center !important;
        width: 6% !important;
    }

    .bilologiclist .clustersublist > li > div:nth-child(5) {
        width: 5% !important;
    }

    .bilologiclist .clustersublist > li > div:nth-child(6) {
        text-align: center !important;
        width: 7.5% !important;
    }

    .bilologiclist .clustersublist > li > div:nth-child(7) {
        width: 7.5% !important;
        text-align: center !important;
    }

    .bilologiclist .clustersublist > li > div:nth-child(8) {
        text-align: center !important;
        width: 8.5% !important;
    }

    .bilologiclist .clustersublist > li > div:nth-child(9) {
        text-align: center !important;
        width: 8.5% !important;
        padding-right: 0px !important;
    }

    .bilologiclist .clustersublist > li > div:nth-child(10) {
        text-align: center !important;
        width: 8.5% !important;
        padding-right: 0px !important;
    }

    .bilologiclist .clustersublist > li > div:nth-child(11) {
        text-align: right !important;
        width: 13% !important;
        padding-right: 0px !important;
    }

    .button-discharge {
        animation: live-icon 2s infinite;
    }

    .bill-mrn {
        direction: rtl
    }

    .dashboardblock > ul > .itemlisthead {
        position: absolute !important;
        top: 39px;
        left: 0;
        z-index: 2;
        width: calc(100% - 6px);
    }

    .itemlisttable {
        scrollbar-width: thin;
    }

    ::-webkit-scrollbar {
        width: 6px;
    }
</style>
